
import React from "react";
import { Client } from "@/models/Client";
import { useWorkoutTypes } from "@/hooks/useWorkoutTypes";
import { useTranslation } from "react-i18next";
import { ScrollArea } from "@/components/ui/scroll-area";
import ClientSessionsModalHeader from "./ClientSessionsModalHeader";
import SessionsModalContent from "./SessionsModalContent";
import SessionsModalActions from "./SessionsModalActions";

interface ClientSessionsModalContentWrapperProps {
  client: Client;
  sessionData: { [key: string]: number };
  onSessionChange: (subscriptionId: string, value: string) => void;
  onViewHistory: () => void;
  onViewPaymentHistory: () => void;
  onCancel: () => void;
  onSave: () => void;
  onReset: () => void;
  isPending: boolean;
}

const ClientSessionsModalContentWrapper: React.FC<ClientSessionsModalContentWrapperProps> = ({
  client,
  sessionData,
  onSessionChange,
  onViewHistory,
  onViewPaymentHistory,
  onCancel,
  onSave,
  onReset,
  isPending,
}) => {
  const { t } = useTranslation();
  const { workoutTypes = [] } = useWorkoutTypes();

  const getWorkoutTypeName = (workoutTypeId: string) => {
    const workoutType = workoutTypes.find(wt => wt.id === workoutTypeId);
    return workoutType?.name || t('clients.unknownWorkoutType');
  };

  const activeSubscriptions = client.subscriptions.filter(sub => sub.isActive);

  return (
    <div className="flex flex-col h-full max-h-[calc(100vh-200px)]">
      <ClientSessionsModalHeader
        onViewHistory={onViewHistory}
        onViewPaymentHistory={onViewPaymentHistory}
      />

      <ScrollArea className="flex-1 pr-4">
        <SessionsModalContent
          client={client}
          activeSubscriptions={activeSubscriptions}
          sessionData={sessionData}
          onSessionChange={onSessionChange}
          getWorkoutTypeName={getWorkoutTypeName}
        />
      </ScrollArea>

      <div className="flex-shrink-0 mt-4 pt-4 border-t bg-background">
        <SessionsModalActions
          onCancel={onCancel}
          onSave={onSave}
          onReset={onReset}
          isPending={isPending}
          hasActiveSubscriptions={activeSubscriptions.length > 0}
        />
      </div>
    </div>
  );
};

export default ClientSessionsModalContentWrapper;
